const EMBED_URL = 'https://bikeverse.ro/nh-velo-mini-express';

export default function MiniExpress() {
  return (
    <div className="fixed inset-x-0 top-16 bottom-0 bg-gray-100">
      <iframe
        src={EMBED_URL}
        allow="payment"
        title="Mini Express"
        className="h-full w-full border-0"
      />
    </div>
  );
}
